import { GetProductQuery, Product, useGetProductQuery } from "generated/graphql";
import { useCallback, useMemo } from "react";

export const useGetProduct = ({ id }: { id: Product["id"] }) => {
  const {
    loading,
    error,
    data: graphqlData,
  } = useGetProductQuery({
    variables: {
      id,
    },
  });

  const getData = useCallback(({ data }: { data: GetProductQuery }) => {
    return data?.getProduct || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData]);

  return { loading, error, data, getData };
};
